module.exports = __webpack_public_path__ + "img/popup_battery_1.9c0af8ef.svg";